import React from 'react'

import { Icon, SuccessFilled } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, func, string } from 'prop-types'

import TierCard from 'Pods/Profile/Settings/SubscriptionManagement/Shared/TierCard/TierCard'
import highlightTranslation from 'Pods/Shared/Utils/highlightTranslation'

import formatPrice from 'Utils/formatPrice'

import { PLAN_TYPE } from '../../../constants'
import { availablePlansShape, catalogValuesShape, planChangeTargetShape } from '../../../propTypes'
import buildTierCards from '../planChangeOptions'
import CardAction from './CardAction'

const KEY = 'subscription_management.plan_change'
const CHECKOUT_FEATURES_KEY = 'subscription_checkout.plans_restructure.plan_card.features'
const BADGE_ICON_SIZE = { width: '16', height: '16' }

const FEATURE_SLOTS = ['first', 'second', 'third']

function planFeatures(translate, tier, plan, catalog) {
  const counts = { modelCount: catalog, downloads: plan.downloadsPerMonth, generations: plan.generationsPerMonth }
  return FEATURE_SLOTS.map((slot) => translate(`${CHECKOUT_FEATURES_KEY}.${tier}.${slot}`, counts))
}

function TierStep({
  tier,
  billingTerm,
  targets,
  availablePlans,
  catalogValues = null,
  upgradeUrl,
  effectiveDate = null,
  onSelect,
  translate,
}) {
  const termLabel = (term) => translate(`${KEY}.terms.${term}`)
  const tierName = (cardTier) => translate(`${KEY}.tiers.${cardTier}`)

  return (
    <div className="plan-change-modal__body">
      <p className="cgt-body-base plan-change-modal__intro">{translate(`${KEY}.intro`)}</p>
      <div className="plan-change-modal__cards">
        {buildTierCards({ tier, billingTerm, targets }).map((card) => {
          const plan = availablePlans[card.tier]
          const term = card.showAnnualPrice ? PLAN_TYPE.ANNUAL : PLAN_TYPE.MONTHLY
          const catalog = catalogValues?.[card.tier]

          return (
            <TierCard
              key={card.tier}
              tier={card.tier}
              name={tierName(card.tier)}
              price={formatPrice(card.showAnnualPrice ? plan.annualPrice : plan.monthlyPrice)}
              priceTerm={translate(`${KEY}.per_term.${term}`)}
              priceNote={card.showAnnualPrice
                ? translate(`${KEY}.price_note_annual`, { catalog })
                : translate(`${KEY}.price_note_monthly`, { annualPrice: formatPrice(plan.annualPrice), catalog })}
              features={planFeatures(translate, card.tier, plan, catalog)}
              badge={card.current && (
                <span className="cgt-overline-md plan-change-modal__current">
                  <Icon
                    svgComponent={SuccessFilled}
                    size={BADGE_ICON_SIZE}
                    className="plan-change-modal__success-icon"
                    notSpaced
                  />
                  {translate(`${KEY}.current_badge`)}
                </span>
              )}
              divider
            >
              <CardAction
                card={card}
                planName={tierName(card.tier)}
                upgradeUrl={upgradeUrl}
                effectiveDate={effectiveDate}
                onSelect={onSelect}
                translate={translate}
              />
            </TierCard>
          )
        })}
      </div>
      <p className="cgt-caption plan-change-modal__current-plan">
        {highlightTranslation(translate, `${KEY}.current_plan`, {
          plan: translate(`${KEY}.plan_label`, { tier: tierName(tier), term: termLabel(billingTerm) }),
        }, 'cgt-caption-semibold plan-change-modal__current-plan-name')}
      </p>
    </div>
  )
}

TierStep.propTypes = {
  tier: string.isRequired,
  billingTerm: string.isRequired,
  targets: arrayOf(planChangeTargetShape).isRequired,
  availablePlans: availablePlansShape.isRequired,
  catalogValues: catalogValuesShape,
  upgradeUrl: string.isRequired,
  effectiveDate: string,
  onSelect: func.isRequired,
  translate: func.isRequired,
}

export default TierStep
